import React from "react";
import DropdownFieldWrapper from "./DropdownFieldWrapper";
import TextFieldWrapper from "./TextFieldWrapper";
import DatePickerWrapper from "./DatePickerWrapper";
import { MetadataElement} from "./SingleUploadModel";
import CheckboxWrapper from "./CheckboxWrapper";
import DropdownFieldWrapperCascade from "./DropdownFieldWrapperCascade";

interface EditableFieldProps {
  element: MetadataElement;
  rowIndex?: number | null; // Added rowIndex prop
  assetId?: string; // Optional prop for assetId
}

const EditableField: React.FC<EditableFieldProps> = ({ element , rowIndex,assetId}) => {
  if (element.is_domained === "Y" && element.is_cascade === "N") {
    return <DropdownFieldWrapper element={element} rowIndex={rowIndex} assetId={assetId} />;
  }
  if (element.is_domained === "Y" && element.is_cascade === "Y") {
    return <DropdownFieldWrapperCascade element={element} rowIndex={rowIndex} assetId={assetId} />;
  }

  if (element.datatype === "DATE") {
    return <DatePickerWrapper element={element} />;
  }
  if(element.datatype ==="CHECKBOX"){
    return <CheckboxWrapper element={element} rowIndex={rowIndex} />;
  }
  return <TextFieldWrapper element={element} rowIndex={rowIndex}/>;
};

export default EditableField;